import { SkeletonBlock } from './Skeleton';
import { SkeletonBreath, SkeletonCircle, SkeletonText } from './skeletonPrimitives';

function CardSkeleton({
  titleWidth = 'w-40',
  rows = 7,
}: {
  titleWidth?: string;
  rows?: number;
}) {
  return (
    <section className="flex w-full flex-col gap-4 rounded-card border border-slate-200/50 bg-white p-6 sm:p-8">
      <div className="flex items-center gap-2">
        <SkeletonCircle className="size-[22px]" />
        <SkeletonText className={titleWidth} />
      </div>
      <div className="grid gap-2">
        {Array.from({ length: rows }).map((_, idx) => (
          <div key={idx} className="flex items-center justify-between gap-3">
            <SkeletonText className="w-28 sm:w-36" />
            <SkeletonText className="w-24 sm:w-40" />
          </div>
        ))}
      </div>
    </section>
  );
}

function PaymentSkeleton() {
  return (
    <section className="flex w-full flex-col gap-4 rounded-card border border-slate-200/50 bg-white p-6 sm:p-8">
      <div className="flex items-center gap-2">
        <SkeletonCircle className="size-[22px]" />
        <SkeletonText className="w-44" />
      </div>

      <div className="flex flex-wrap items-center gap-2">
        <SkeletonBlock className="h-6 w-[240px] sm:w-[320px] rounded-[16px]" />
        <SkeletonBlock className="h-10 w-28 rounded-[16px]" />
      </div>

      <div className="flex items-start gap-2 rounded-[16px] border border-primary/10 bg-primary/5 px-4 py-3">
        <SkeletonCircle className="size-5" />
        <div className="flex-1 space-y-2">
          <SkeletonText className="w-full" />
          <SkeletonText className="w-[90%]" />
          <SkeletonText className="w-[60%]" />
        </div>
      </div>
    </section>
  );
}

export function PayerDealViewSkeleton() {
  return (
    <SkeletonBreath>
      <div className="mb-2 flex w-full max-w-2xl flex-col items-center gap-6">
        <div className="mb-2 flex flex-col items-center gap-2">
          <SkeletonBlock className="h-[39px] w-[120px] rounded-[16px]" />
          <SkeletonText className="w-[260px] sm:w-[320px]" />
        </div>

        <CardSkeleton titleWidth="w-52" rows={8} />
        <CardSkeleton titleWidth="w-44" rows={6} />
        <PaymentSkeleton />
      </div>
    </SkeletonBreath>
  );
}
